import React, { Component } from 'react';
import { NavHashLink } from 'react-router-hash-link';
import { MenuItems } from "./menuItems"
import "../styles/navbar.css"


class Navbar extends Component {
    state = { 
        clicked: false,
        activeItem: "",
    }
     
     handleOpen = () => {
        this.setState({ open: !this.state.open })
     }

    render() {
        return(
            <nav className="NavbarItems">

                <h1 className="navbar-logo">
                    <NavHashLink to='/#top' smooth style={{color:'white'}}> MoU-II </NavHashLink>
                </h1> 

             <div id="navbar">
                <div className="menu-icon" onClick={this.handleOpen}>
                    <i className={this.state.open ? 'fas fa-times' : 'fas fa-bars'}></i>
                </div> 
  
                <ul className={this.state.open ? 'nav-menu active' : 'nav-menu'}>

                    {MenuItems.map((item, index) => {
                        return (
                            <li 
                                key={index} 
                            >
                                <NavHashLink 
                                    to={item.url}
                                    activeClassName="activee"
                                    smooth
                                    onClick={this.handleOpen}
                                >
                                    {item.title}
                                </NavHashLink>
                            </li>
                        )
                    })}
                </ul>
             </div>
            </nav>
        )
    }
}

export default Navbar